// The underline of a form field, as a Tailwind class string — shared by the
// dashboard's UnderlineField/UnderlineSelect and the ui Input, so every text
// field is one look as the TextField (`.nu-uin`): 1.5px at rest, the same line
// turning teal on focus, 15.5px text, 44px tall.
//
// Browser autofill paints its own (white / pale-blue / yellow) box over the
// input through a UA `!important` background that can't be overridden. Delaying
// the background transition indefinitely keeps the transparent underline field
// intact, and the text-fill override stops WebKit recolouring the value.
const AUTOFILL_CLS =
  'autofill:[transition:background-color_600000s_0s,color_600000s_0s] autofill:[-webkit-text-fill-color:var(--color-text-primary)]';

export const UNDERLINE_INPUT_CLS = `w-full border-0 border-b-[1.5px] border-(color:--nuberu-line-strong) bg-transparent py-[9px] text-[15.5px] text-text-primary outline-none placeholder:text-(color:--nuberu-copy-faint) focus:border-(color:--nuberu-teal) disabled:cursor-not-allowed disabled:opacity-60 ${AUTOFILL_CLS}`;
